import { gql } from '@apollo/client';

export const SELECT_QUERY = gql`
  query FetchHomePageData($admissionId: UUID!) {
    admission: admissionById(id: $admissionId) {
      id
      endedAt
      room {
        id
        floorId
        floor {
          id
          type
        }
      }
    }
    survey: releasedSurveys(
      first: 1
      filter: { admissionId: { equalTo: $admissionId } }
      orderBy: CREATED_AT_DESC
    ) {
      nodes {
        id
        surveyId
        createdAt
        status
        survey {
          scheduleData
          config
        }
      }
    }
    conciergeConfigs(
      filter: {
        type: { in: [APP_NOTIFICATION, APP_FRONT_PAGE] }
        enabled: { equalTo: true }
      }
    ) {
      nodes {
        id
        type
        data
        condition
        createdAt
      }
    }
  }
`;

export const SERVICES_QUERY = gql`
  query FetchFloorServices($floorId: UUID!) {
    assistanceServices: patientCallGroupItems(
      filter: {
        and: [
          { group: { locationIds: { anyEqualTo: $floorId } } }
          { service: { category: { equalTo: ASSISTANCE } } }
        ]
      }
    ) {
      totalCount
    }
    otherServices: patientCallGroupItems(
      filter: {
        and: [
          { group: { locationIds: { anyEqualTo: $floorId } } }
          { service: { category: { equalTo: INFRASTRUCTURE } } }
        ]
      }
    ) {
      totalCount
    }
    feedbackConfigs(filter: { data: { containsKey: "displayOnConcierge" } }) {
      nodes {
        id
        data
      }
    }
    hospitalInformationSections(filter: { enabled: { equalTo: true } }) {
      totalCount
    }
  }
`;

export const SURVEY_SUBSCRIPTION = gql`
  subscription OnReleasedSurveyChanged($admissionId: UUID!) {
    releasedSurveyChangesByAdmission(admissionId: $admissionId) {
      releasedSurvey {
        id
        surveyId
        createdAt
        status
      }
    }
  }
`;
